import type { TTestimonialCard } from "@/components/organisms/TestimonialCard/types";

export const testimonialSliderId = "testimonials-slider";

// no final do slide faz o slide para renderizar no máximo 6 cards
export const testimonialCards: Omit<
  TTestimonialCard,
  "sliderId" | "indexCard" | "lastIndexArray"
>[] = [
  {
    testimonial:
      '"Há mais de um ano, conto com os serviços da Data Stone, e a experiência tem sido excepcional. A assertividade na entrega de soluções me permite alcançar exatamente o público-alvo desejado, alinhado aos meus objetivos. Além disso, a responsabilidade, rapidez e eficiência da equipe têm trazido enormes benefícios ao meu negócio. A parceria com a Data Stone reflete lealdade, clareza e um compromisso admirável. Recomendo sem hesitação!"',
    author: "ALEXANDRE SANTOS",
    company: "Pentágono",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
  {
    testimonial:
      "“Praticidade e facilidade definem a experiência que tivemos com a Data Stone. Desde o início, a empresa superou nossas expectativas, trazendo soluções que realmente fizeram a diferença. Eles nos ajudaram significativamente a otimizar nossa produção e elevar a produtividade a um novo patamar. Foi uma parceria excelente, que recomendamos com certeza!”",
    author: "ALEXIS",
    company: "RH Simoes PJ",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
  {
    testimonial:
      '"Ótima plataforma! Fácil de navegar, oferece bons contatos e proporciona uma excelente experiência. O atendimento comercial é de primeiro nível. A Data Stone tem tudo para criar um oceano azul no mercado!"',
    author: "MICHEL",
    company: "Máquina Lead",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
  {
    testimonial:
      "“A plataforma é intuitiva, oferece dados assertivos e conta com um suporte sempre acessível, seja para tirar dúvidas ou para facilitar o processo de vendas. Com ela, consigo contatos altamente qualificados, o que impulsiona nossa comunicação, negociação e conversão em vendas. Destaco também o compromisso da Data Stone com a qualidade dos dados fornecidos, o que faz toda a diferença no nosso dia a dia.”",
    author: "ANDRESSA",
    company: "CONFI",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
  {
    testimonial:
      "“A plataforma é intuitiva, oferece dados assertivos e conta com um suporte sempre acessível, seja para tirar dúvidas ou para facilitar o processo de vendas. Com ela, consigo contatos altamente qualificados, o que impulsiona nossa comunicação, negociação e conversão em vendas. Destaco também o compromisso da Data Stone com a qualidade dos dados fornecidos, o que faz toda a diferença no nosso dia a dia.”",
    author: "ANDRESSA",
    company: "CONFI",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
  {
    testimonial:
      '"Utilizo a plataforma da Data Stone principalmente para criação de listas e consultas, e a experiência tem sido excelente. O maior benefício está na simplicidade e na velocidade de uso, além da alta qualidade na criação de listas para prospecção, que são bem completas. Gosto tanto da ferramenta que já a indiquei para várias pessoas. Destaco ainda a facilidade na contratação, a agilidade no atendimento da Antonia Mesquita e o enriquecimento de dados, que fazem toda a diferença para o sucesso das listas que crio."',
    author: "FÁBIO SIQUEIRA",
    company: "V4 Company - Verderosi & Co",
    image: {
      src: "https://tse3.mm.bing.net/th/id/OIP.8n8anCWueuED_SJoqlM7owHaHb?rs=1&pid=ImgDetMain&o=7&rm=3",
      alt: "people-image",
    },
  },
].slice(-6);
